export default {"src":"/_next/static/media/AppStoreText.447e252c.svg","height":18,"width":84,"blurWidth":0,"blurHeight":0};